import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    BooleanColumn,
    DateTimeColumn,
    FloatColumn,
    NumberColumn,
    TextColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Despatch',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predesMessage.despatchS8Id')
          .withTotalHeader('Total')),
        new TextColumn('Category', 'predesMessage.mailCategory', false),
        new TextColumn('Subclass', 'predesMessage.mailSubClass', false),
        new DateTimeColumn('Despatch close date', 'predesMessage.despatchClosedDateTime', false),
        new TextColumn('Day', 'predesMessage.despatchClosedDayOfWeek', false),
        new TextColumn('First leg', 'predesMessage.firstTransportLeg.name', false),
        new DateTimeColumn(
          'Planned departure date',
          'predesMessage.firstTransportLeg.scheduledLocalDateTime',
          false,
        ),
        new TextColumn('Last leg', 'predesMessage.lastTransportLeg.name', false),
        new DateTimeColumn(
          'Planned arrival date',
          'predesMessage.lastTransportLeg.scheduledLocalDateTime',
          false,
        ),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NumberColumn('PREDES', 'details.predesCount', false),
        new NumberColumn('RESDES', 'details.resdesCount', false),
      ],
    },
    {
      Header: 'Receptacle',
      columns: [
        new TextColumn('Receptacle ID', 'details.receptacle.s9', false),
        new TextColumn('Receptacle type', 'details.receptacle.type', false),
        new TextColumn('FOC', 'details.receptacle.formatOfContents', false),
        new TextColumn('HC', 'details.receptacle.handingClass', false),
        new BooleanColumn('Tracked', 'details.receptacle.tracked', false),
        new FloatColumn('Weight', 'details.receptacle.weight', false)
          .withTotalHeader(sumRoundedTotal),
        new NumberColumn('Items', 'details.receptacle.itemCount', false)
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('Event date', 'details.resdes.eventDateTime', false),
        new DateTimeColumn('Arrival date', 'details.resdes.resdesArrivalDateTime', false),
        new TextColumn('Carrier', 'details.resdes.carrier', false),
      ],
    },
    {
      Header: 'EMSEVT',
      columns: [
        new BooleanColumn('EMD', 'details.emsEvents.emd', false),
        new BooleanColumn('EMI', 'details.emsEvents.emi', false),
      ],
    },
  ];
};
